import { render, staticRenderFns } from "./salesActivityDetails.vue?vue&type=template&id=386318c8&scoped=true&"
import script from "./salesActivityDetails.vue?vue&type=script&lang=js&"
export * from "./salesActivityDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesActivityDetails.vue?vue&type=style&index=0&id=386318c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386318c8",
  null
  
)

component.options.__file = "salesActivityDetails.vue"
export default component.exports